import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { routesConfig } from '../../../shared/onboardingConfig';
import { CONSENTS_FLOW } from '../../../shared/onboardingConstants';
import { useOnboardingContext } from '../../../state/OnboardingContext';
import { stepToUrl } from '../../../shared/onboardingUtils';

import Welcome from '../../steps/consents/Welcome';
import TermsOfService from '../../steps/consents/TermsOfService';
import PrivacyPolicy from '../../steps/consents/PrivacyPolicy/PrivacyPolicy';
import DirectPromotion from '../../steps/shared/DirectPromotion';
import Health from '../../steps/consents/Health';
import HealthDenialOne from '../../steps/consents/HealthDenialOne';
import HealthDenialTwo from '../../steps/consents/HealthDenialTwo';
import AllSet from '../../steps/consents/AllSet';

const ConsentsFlowRoutes = () => {
  const { state } = useOnboardingContext();
  const { category } = state;

  return (
    <Switch>
      <Route
        path={stepToUrl({ category, step: CONSENTS_FLOW.welcome })}
        {...routesConfig}
      >
        <Welcome />
      </Route>
      <Route
        path={stepToUrl({ category, step: CONSENTS_FLOW.termsOfService })}
        {...routesConfig}
      >
        <TermsOfService />
      </Route>
      <Route
        path={stepToUrl({ category, step: CONSENTS_FLOW.privacyPolicy })}
        {...routesConfig}
      >
        <PrivacyPolicy />
      </Route>
      <Route
        path={stepToUrl({ category, step: CONSENTS_FLOW.health })}
        {...routesConfig}
      >
        <Health />
      </Route>
      <Route
        path={stepToUrl({ category, step: CONSENTS_FLOW.privacyPolicy })}
        {...routesConfig}
      >
        <DirectPromotion />
      </Route>
      <Route
        path={stepToUrl({ category, step: CONSENTS_FLOW.health_denial_one })}
        {...routesConfig}
      >
        <HealthDenialOne />
      </Route>
      <Route
        path={stepToUrl({ category, step: CONSENTS_FLOW.health_denial_two })}
        {...routesConfig}
      >
        <HealthDenialTwo />
      </Route>
      <Route
        path={stepToUrl({ category, step: CONSENTS_FLOW.directPromotion })}
        {...routesConfig}
      >
        <DirectPromotion />
      </Route>
      <Route
        path={stepToUrl({ category, step: CONSENTS_FLOW.all_set })}
        {...routesConfig}
      >
        <AllSet />
      </Route>
    </Switch>
  );
};

export default ConsentsFlowRoutes;
